export default __webpack_public_path__ + "static/media/circle-play.f2fbbe2a.svg";